import { Box, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Tooltip, Text } from "@chakra-ui/react";
import { ReactComponent as ContextMenuIcon } from '../../svg/ContextMenu.svg'
import { ReactComponent as Approved } from '../../svg/enabledTopic.svg'
import { ReactComponent as Declined } from '../../svg/disabledTopic.svg'
import { ReactComponent as Pending } from '../../svg/warning.svg'


export default function IndividualStudentCard({ image, name, email, studentStatus, classId, id, mobileNumber, method }) {

    return (
        <Box
            d='flex'
            width='100%'
            bg='white'
            borderRadius='20px'
            my='1rem'
            p='1rem'
            px='1rem'
            justifyContent='flex-start'
            alignItems='center'
            _hover={{ boxShadow: 'xl' }}
            position='relative'
        >
            <Box d='flex' width={['15%', '15%', '15%', '25%']} flexDir={['column', 'column', 'column', 'row']} alignItems={['center', 'center', 'center', null]}>
                <Image src={image} width={['50px', '50px', '50px', '50px']} height={['50px', '50px', '50px', '50px']} borderRadius='50%' fallbackSrc="https://source.unsplash.com/random/800x600" mr='2' objectFit='cover' />
                <Box d='flex' flexDir='column' justifyContent='center' alignItems={['center', 'center', 'center', 'flex-start']} w='100%'>
                    <Tooltip
                        label={name}
                        fontSize='15px'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='400'
                        color='#ffffff'
                        bg='#1B1A1AB2'
                        hasArrow
                        placement='top'
                    >
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontWeight='700'
                            fontSize={['14px', '14px', '16px', '16px']}
                            color='#333333'
                            whiteSpace='nowrap'
                            overflow='hidden'
                            textOverflow='ellipsis'
                            cursor='pointer'
                            w={['100%', '100%', '100%', '80%']}
                        >
                            {name ? name : 'Teacher Name'}
                        </Text>
                    </Tooltip>
                </Box>
            </Box>

            <Box d='flex' width={['30%', '30%', '30%', '25%']} height='100%' justifyContent='center' alignItems='center'>
                <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['14px', '14px', '16px', '16px']}>{email}</Text>
            </Box>

            <Box d='flex' width={['30%', '30%', '30%', '22.5%']} height='100%' justifyContent='center' alignItems='center'>
                <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['14px', '14px', '16px', '16px']}>{mobileNumber}</Text>
            </Box>

            <Box d='flex' width={['30%', '30%', '30%', '22.5%']} justifyContent='center' alignItems='center'>
                <Box
                    bg={studentStatus === 'A' ? '#4ea348' : studentStatus === 'D' ? '#c91d12' : "#ff8c00"}
                    border='2px solid #FFFFFF'
                    boxShadow='0px 2px 6px rgba(0, 0, 0, 0.1)'
                    p='10px 20px'
                    borderRadius='20px'
                    style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                    fontWeight='700'
                    color='#ffffff'
                    fontSize={['7px', '10px', '11px', '15px']}
                    d='flex'
                    justifyContent='center'
                    alignItems='center'
                >
                    {studentStatus === 'A' ? <Approved width='15px' height='15px' /> : studentStatus === 'D' ? <Declined width='15px' height='15px' /> : <Pending width='15px' height='15px' fill="#ffffff" />}
                    {studentStatus === 'A' ? 'Approved' : studentStatus === 'D' ? 'Declined' : 'Pending'}
                </Box>
            </Box>

            <Menu>
                <MenuButton
                    as={IconButton}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    icon={<ContextMenuIcon />}
                    bg='white'
                    _hover={{ bg: "#f8f8f8" }}
                    _active={{ bg: "#f8f8f8" }}
                    position={['absolute', 'absolute', 'absolute', 'static']}
                    right='0'
                    top='0'
                    size={['xs', 'sm', 'sm', 'lg']}
                    p='0.5rem 1rem'
                />
                <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px' color='#00000099' minW='0' w='150px' position='relative' zIndex='10'>
                    <MenuItem onClick={() => method(id, classId, 'A')} >Approve</MenuItem>
                    <MenuItem onClick={() => method(id, classId, 'D')} >Decline</MenuItem>
                </MenuList>
            </Menu>
        </Box>
    )
}